module.exports = __webpack_public_path__ + "static/media/chhaaata_chhaaa.423ba340.ogg";